<table *ngIf="loadingCompleted" [style.background]="backgroundColor">
  <thead>
    <tr [style.color]="highlightColor">
      <th>Sun</th>
      <th>Mon</th>
      <th>Tue</th>
      <th>Wed</th>
      <th>Thu</th>
      <th>Fri</th>
      <th>Sat</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td >
        <div class="activities" *ngIf="currentDayOfTheWeek<3">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-28]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-28]?.length>0 ? '' : '3vw'">
        {{ currentDayOfTheWeek<3 ? addDay(-currentDayOfTheWeek -28) : ''}}
        </div>
      </td>
      <td >
        <div class="activities"  *ngIf="currentDayOfTheWeek<4">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-27]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-27]?.length>0 ? '' : '3vw'">
        {{ currentDayOfTheWeek<4 ? addDay(-currentDayOfTheWeek -27) : ''}}
        </div>
      </td>
      <td>
        <div class="activities" *ngIf="currentDayOfTheWeek<5">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-26]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-26]?.length>0 ? '' : '3vw'">
        {{ currentDayOfTheWeek<5 ? addDay(-currentDayOfTheWeek -26) : ''}}</div></td>
      <td >
        <div class="activities" *ngIf="currentDayOfTheWeek<6">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-25]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-25]?.length>0 ? '' : '3vw'">
        {{ currentDayOfTheWeek<6 ? addDay(-currentDayOfTheWeek -25) : ''}}
        </div>
      </td>
      <td >
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-24]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-24]?.length>0 ? '' : '3vw'">
        {{addDay(-currentDayOfTheWeek -24)}}</div></td>
      <td >
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-23]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-23]?.length>0 ? '' : '3vw'">
        {{addDay(-currentDayOfTheWeek -23)}}</div></td>
      <td >
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-22]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText"  [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-22]?.length>0 ? '' : '3vw'">
        {{addDay(-currentDayOfTheWeek -22)}}</div></td>

    </tr>
    <tr>
      <td *ngFor="let day3 of [21,20,19,18,17,16,15]">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-day3]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText"  [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-day3]?.length>0 ? '' : '3vw'">
        {{addDay(-currentDayOfTheWeek -day3)}}
        </div>
      </td>
    </tr>
    <tr>
      <td *ngFor="let day2 of [14,13,12,11,10,9,8]">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-day2]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText"  [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-day2]?.length>0 ? '' : '3vw'">
          {{addDay(-currentDayOfTheWeek -day2)}}
        </div>
      </td>
    </tr>
    <tr>
      <td *ngFor="let day1 of [7,6,5,4,3,2,1]">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek-day1]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek-day1]?.length>0 ? '' : '3vw'">
          {{addDay(-currentDayOfTheWeek -day1)}}
        </div></td>
    </tr>
    <tr>
      <td [class.today]="currentDayOfTheWeek===0" [style.color]="currentDayOfTheWeek===0? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===0 ? currentDate : addDay(-currentDayOfTheWeek)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<1" [class.today]="currentDayOfTheWeek===1" [style.color]="currentDayOfTheWeek<2? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+1]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+1]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===1 ? currentDate : addDay(-currentDayOfTheWeek + 1)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<2" [class.today]="currentDayOfTheWeek===2" [style.color]="currentDayOfTheWeek<3? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+2]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+2]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===2 ? currentDate : addDay(-currentDayOfTheWeek + 2)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<3" [class.today]="currentDayOfTheWeek===3" [style.color]="currentDayOfTheWeek<4? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+3]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+3]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===3 ? currentDate : addDay(-currentDayOfTheWeek + 3)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<4" [class.today]="currentDayOfTheWeek===4" [style.color]="currentDayOfTheWeek<5? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+4]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+4]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===4 ? currentDate : addDay(-currentDayOfTheWeek + 4)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<5" [class.today]="currentDayOfTheWeek===5" [style.color]="currentDayOfTheWeek<6? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+5]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+5]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===5 ? currentDate : addDay(-currentDayOfTheWeek + 5)}}</div></td>
      <td [class.future]="currentDayOfTheWeek<6" [class.today]="currentDayOfTheWeek===6" [style.color]="currentDayOfTheWeek<7? highlightColor: ''">
        <div class="activities">
          <div *ngFor="let item of activitiesCalendar[-currentDayOfTheWeek+6]" [class]="item.type.toLowerCase()"></div>
        </div>
        <div class="tdText" [style.marginLeft]="activitiesCalendar[-currentDayOfTheWeek+6]?.length>0 ? '' : '3vw'">
        {{currentDayOfTheWeek===6 ? currentDate : addDay(-currentDayOfTheWeek + 6)}}</div></td>
    </tr>
  </tbody>
</table>
<div class="spinner" *ngIf="!loadingCompleted">
  <ion-spinner></ion-spinner>
</div>
